export * from './css'
export * from './icon-names'
export * from './drag-and-drop'

export type NamedColor =
  | 'inherit'
  | 'primary'
  | 'secondary'
  | 'error'
  | 'info'
  | 'success'
  | 'warning'

export type NamedIconColor = NamedColor | 'action' | 'disabled'
export type NamedIconButtonColor = NamedColor | 'gray' | 'default'
export type NamedButtonColor = NamedColor | 'gray' | 'white'

export type NamedSize = 'inherit' | 'small' | 'medium' | 'large'

export enum CursorPositionY {
  top,
  bottom,
  center,
}
